<div class="checkin__navbar__aditional__info__item" (click)="onClick(item)" routerLinkActive="active">
  <span class="checkin__navbar__aditional__info__item__icon">
    <i class="{{ item.icon }}"></i>
  </span>
  <span class="checkin__navbar__aditional__info__item__title">
    {{ item?.label?.slug | translate:item?.label?.params }}
  </span>
  <ng-template appAdHost></ng-template>
</div>
